import {TweenMax, ScrollToPlugin} from 'gsap/all';
import inView from 'in-view';

[ScrollToPlugin];

const coverVideoBg = require('./coverVideoBg');
const videoBg = require('./videoBg');
const analyticsEvent = require('../../viscomjs/analytics/analyticsEvent');
const MouseInteractionSingleton = require('../../viscomjs/interactions/MouseInteractionSingleton');
const SectionControllerFactory = require('./SectionControllerFactory');
const ViewportsResizeBehaviour = require('./behaviors/ViewportsResizeBehaviour');
const ViewportsPortraitResizeBehaviour = require('./behaviors/ViewportsPortraitResizeBehaviour');
const ViewportsSyncTopResizeBehaviour = require('./behaviors/ViewportsSyncTopResizeBehaviour');
const NoneViewportsResizeBehaviour = require('./behaviors/NoneViewportsResizeBehaviour');
const OptionSwitcher = require('./ui/OptionSwitcher');
const CounterButton = require('./ui/CounterButton');
const SizeMode = require('./utils/SizeMode');
const MIS = MouseInteractionSingleton();
const model = require('./Model');

const body = document.body;
const state = {
    layer: 'cover',
    layerChanged: false,
    availableNumStages: 3,
    numStages: 4,
    prevStage: -1,
    stage: -1,
    // stage: 0,
    firstStage: 0,
    stageChanged: false,
    lastStageChaneTimestamp: new Date().getTime(),
    review: {
        region: null
    }
};

let sectionsControls = [];
let sectionsNames = [];
let sections = [];
let sectionInView = [];
let sectionBasicContentsInView = [];
let sectionDetailsInView = [];
let sectionUIInView = [];
let sectionDetailsItemsInView = null;
let scrollTransition = false;

let currentSection = null;
let fixSectionsControl = null;
let reviewSectionsControl = null;
let sandwichUI = null;
let centralDiagram;
let centralDiagramOlPt;
let centralDiagramBack;
let totalValueDisplay;
let diagramFeaturesControl;
let previewIlln;
let coverNextUI;
let paginationUI;
let sectionsUI = [];
let sectionsNextButtons = [];
let sectionsBackButtons = [];
let sectionsCounterUIs = [];

let vpsResizeBehaviour;
let vpsResizeBehaviourAside;
const __reviewDetails = require('./data').sections[0].details;

function _initUI() {
    // const DragablePointUI = require('./ui/DragablePointUI');
    const Pagination = require('./ui/Pagination');
    // coverNextUI = DragablePointUI(document.querySelector('.cover__next-ui .dragable-point'));
    const CoverNextButton = require('./ui/CoverNextButton');
    coverNextUI = CoverNextButton(document.querySelector('.cover__next-button a'));

    paginationUI = Pagination(document.querySelector('.pagination'));

    sectionsNextButtons = sectionsNames.map(name => {
        return [...document.querySelectorAll(`.section[data-stage-name="${name}"] [data-section-next-ui]`)];
    });
    _updateNextUI(state.firstStage + state.availableNumStages - 1, false);

    sectionsBackButtons = sectionsNames.map(name => {
        return [...document.querySelectorAll(`.section[data-stage-name="${name}"] [data-section-back-ui]`)];
    });

    // TODO: move to sectionsUI
    sectionsCounterUIs = sectionsNames.map(name => {
        return [...document.querySelectorAll(`.section[data-stage-name="${name}"] [data-counter]`)].map(el => CounterButton(el));
    });

    sectionsUI = sectionsNames.map(name => {
        return [...document.querySelectorAll(`.section[data-stage-name="${name}"] [data-section-ui]`)].map(el => {
            if (!el) return null;
            // If there are more UI types than one make a UI Factory according to data parameters
            const ui = OptionSwitcher(el);

            if (state.review.region !== null) {
                ui.setValue(state.review.region);
                return;
            }
            state.review.region = ui.getValue();

            return ui;
        });
    });
}

function _initSections() {
    const arr = [...document.querySelectorAll('.section[data-stage-name]')];
    let fixI = -1;
    let reviewI = -1;
    sections = arr;
    sectionsNames = arr.map((el, i) => {
        if (el.dataset.stageName === 'fix') fixI = i;
        if (el.dataset.stageName === 'review') reviewI = i;
        return el.dataset.stageName;
    });
    sectionsControls = arr.map(el => {
        return SectionControllerFactory.createController(el.dataset.stageName, el).init();
    });
    if (sectionsControls.length > 0) currentSection = sectionsControls[0];
    if (reviewI > -1) reviewSectionsControl = sectionsControls[reviewI];
    if (fixI > -1) fixSectionsControl = sectionsControls[fixI];
}

function _initCentralDiagram() {
    const CentralDiagram = require('./CentralDiagram');
    const CentralDiagramOutlinePoint = require('./CentralDiagramOutlinePoint');
    const CentralDiagramBack = require('./CentralDiagramBack');
    centralDiagram = CentralDiagram(document.querySelector('.sections__viewport.js-vp--main'));
    centralDiagramOlPt = CentralDiagramOutlinePoint(document.querySelector('.sections__viewport.js-vp--main'));
    centralDiagramBack = CentralDiagramBack(
        document.querySelector('.sections__viewport.js-vp--1'),
        document.querySelector('.sections__viewport.js-vp--2')
    ).init();

    centralDiagram.setValues(model.defaultValuesSet);
    centralDiagram.init();
    centralDiagramOlPt.init();
}

function _deinitCentralDiagram() {
    TweenMax.killDelayedCallsTo(_clearTotalValue);

    if (!centralDiagram) return;
    centralDiagram.destroy();
    centralDiagramOlPt.destroy();
    centralDiagramBack.destroy();

    centralDiagram = null;
    centralDiagramOlPt = null;
    centralDiagramBack = null;
}

function _initTotalValueDisplay() {
    const TotalValueDisplay = require('./TotalValueDisplay');
    totalValueDisplay = TotalValueDisplay(document.querySelector('.sections__viewport.js-vp--main [data-total]'));
    totalValueDisplay.init();
}

function _initDiagramFeaturesControl() {
    const DiagramFeaturesControl = require('./DiagramFeaturesControl');
    diagramFeaturesControl = DiagramFeaturesControl(document.querySelector('.sections__viewport.js-vp--main [data-features]'));
    diagramFeaturesControl.init();
}

function _initSandwich() {
    const SandwichUI = require('./ui/SandwichUI');
    sandwichUI = SandwichUI(document.querySelector('.sandwich'));
}

function _deinitSandwich() {
    if (!sandwichUI) return;
    sandwichUI.destroy();
    sandwichUI = null;
}

function _initSectionsMobile() {
    scrollTransition = false;
    sectionInView = sectionsNames.map(name => {
        if (!name) return null;
        return __inViewOffMixin(inView(`[data-stage-name=${name}]`));
    });
    sectionBasicContentsInView = sectionsNames.map(name => {
        if (!name) return null;
        return __inViewOffMixin(inView(`[data-stage-name=${name}] .stage__content`));
    });
    sectionDetailsInView = sectionsNames.map(name => {
        if (!name) return null;
        return __inViewOffMixin(inView(`[data-stage-name=${name}] .stage__details`));
    });
    sectionDetailsItemsInView = __inViewOffMixin(inView('.details__item'));
    sectionUIInView = sectionsNames.map(name => {
        if (!name) return null;
        return __inViewOffMixin(inView(`[data-stage-name=${name}] .stage__ui`));
    });
}

/* const __inViewOff = function (event, handler) {
    let length = this.handlers[event].length;
    let b = true;
    while (--length > -1 && b) {
        if (this.handlers[event][length] === handler) {
            this.handlers[event].splice(length, 1);
            b = false;
        }
    }
}*/

const __inViewRemoveAllListeners = function () {
    let event;
    for (event in this.singles) {
        if (this.singles.hasOwnProperty(event))
            while (this.singles[event].length) {
                this.singles[event].pop();
            }
    }
    for (event in this.handlers) {
        if (this.handlers.hasOwnProperty(event))
            while (this.handlers[event].length) {
                this.handlers[event].pop();
            }
    }
};

const __inViewOffMixin = inview => {
    // inview.off = __inViewOff.bind(inview);
    inview.removeAllListeners = __inViewRemoveAllListeners.bind(inview);

    return inview;
};

function _deinitSectionsMobile() {
    while (sectionInView.length) {
        sectionInView.pop().removeAllListeners();
    }
    while (sectionBasicContentsInView.length) {
        sectionBasicContentsInView.pop().removeAllListeners();
    }
    while (sectionDetailsInView.length) {
        sectionDetailsInView.pop().removeAllListeners();
    }
    while (sectionUIInView.length) {
        sectionUIInView.pop().removeAllListeners();
    }
    if (sectionDetailsItemsInView) sectionDetailsItemsInView.removeAllListeners();
}

function _initPreviewIllustration() {
    const PreviewIllustration = require('./PreviewIllustration');
    previewIlln = PreviewIllustration(document.querySelector('.preview'))
        .init()
        .resize(SizeMode());
}

function _updateCommonElementsDesktop(section) {
    const name = _getSectionName(state.stage);
    const prevName = _getSectionName(state.prevStage);

    let _gotoInitialState = () => {};

    // Enable current
    switch (name) {
        case 'cover':
            // Fulfill if going back to cover is necessary:
            centralDiagram.disable();
            centralDiagram.setValues(model.defaultValuesSet, false, -1);

            coverVideoBg.startcover();

            previewIlln.gotoCover();
            setTimeout(() => {
                if (previewIlln) previewIlln.hide();
            }, 2000);
            break;

        case 'review':
            if (reviewSectionsControl) reviewSectionsControl.setItemsValues(model.getSelectedPresetValues());

            // if (state.isMobile) coverVideoBg.startcoverout();

            centralDiagram.setValues(
                model.getSelectedPresetValues(),
                true,
                prevName === 'cover' || !prevName ? 1 : 2,
                prevName === 'cover' || !prevName ? 0.95 : 0.1
            );

            // Show default selected item:
            _gotoInitialState = () => {
                _diagramReviewSelect(model.getSelectedReviewItemI());
                _updatePointOutline(section.getItemRefY(model.getSelectedReviewItemI()), model.getSelectedReviewCurrentValue());
                centralDiagramOlPt.show(prevName === 'cover' ? 0.95 : 0.05);
            };

            centralDiagram.enable();
            break;

        case 'config':
            centralDiagram.setValues(
                model.getValuesSet(),
                !model.isValuesSetBlank,
                prevName === 'cover' || !prevName ? 1 : 2,
                prevName === 'cover' || !prevName ? 0.95 : 0.1
            );
            _invalidateTotalValue();

            centralDiagram.enable();
            break;

        case 'fix':
            // Hide values
            centralDiagram.setValues(model.defaultValuesSet, false, 0);

            // Show default selected item
            _gotoInitialState = () => {
                _diagramFixDescriptionSelect(model.getSelectedFixIndex());
            };

            centralDiagram.enable();
            break;
    }

    centralDiagram.goto(name);
    centralDiagramBack.goto(name);
    centralDiagram.show();
    centralDiagramBack.show();
    _gotoInitialState();

    diagramFeaturesControl.goto(name);
    if (name === 'config' || name === 'fix') diagramFeaturesControl.enable();
    else {
        diagramFeaturesControl.disable();
    }

    if (name !== 'config') {
        TweenMax.delayedCall(0.6, _clearTotalValue);
    }

    switch (prevName) {
        case 'cover':
            // previewIlln.hide(true);

            previewIlln = null;
            break;

        case 'review':
            _diagramReviewHide();
            centralDiagramOlPt.hide();
            break;

        case 'fix':
            _diagramFixDescriptionHide();
            break;
    }
}

function _invalidateTotalValue() {
    totalValueDisplay.setTotalValue(model.getTotalRisk());
}

function _clearTotalValue() {
    totalValueDisplay.setTotalValue(-1);
}

function _updateCommonElementsMobile() {
    const name = _getSectionName(state.stage);
    const prevName = _getSectionName(state.prevStage);

    // Enable current
    switch (name) {
        case 'cover':
            previewIlln.gotoCover();
            videoBg.start();
            setInterval(() => {
                if (previewIlln) previewIlln.hide();
            }, 2000);
            break;

        case 'review':
            if (reviewSectionsControl) reviewSectionsControl.setItemsValues(model.getSelectedPresetValues());
            break;
    }

    _invalidateTotalValue();

    diagramFeaturesControl.goto('config');
    if (name !== 'cover') diagramFeaturesControl.enable();
    else diagramFeaturesControl.disable();

    switch (prevName) {
        case 'cover':
            // previewIlln.hide(true);

            previewIlln = null;
            break;
    }

    _scrollTo(name);
}

function _scrollTo(name) {
    if (!name || !document.getElementById(name)) return;

    scrollTransition = true;
    TweenMax.to(window, 0.3, {
        scrollTo: {y: '#' + name, autoKill: false},
        onComplete: () => {
            scrollTransition = false;
        }
    });
}

function _scrollToConfig() {
    _scrollTo('config-ui');
}

let _updateCommonElements = _updateCommonElementsDesktop;
function _updateState(force) {
    if (state.layerChanged || force) {
        body.dataset.layer = state.layer;
        state.layerChanged = false;
    }

    if (state.stageChanged || force) {
        const section = _getSection(state.stage);
        if (section) {
            const prevSection = _getSection(state.prevStage);
            _hideSection(prevSection, !state.isMobile, _getSectionName(state.prevStage) === 'cover');
            _showSection(section, prevSection ? 0.5 : 0);
            _updateCommonElements(section);

            body.dataset.stage = _getSectionName(state.stage);

            state.stageChanged = false;
            currentSection = section;
        }

        if (_getSectionName(state.prevStage) === 'cover') {
            _removeCoverStage();

            TweenMax.delayedCall(0.01, () => {
                _handleResize();
            });
        }
    }
}

function _updateUIState(force) {
    let n;
    if (state.stageChanged || force) {
        const section = _getSection(state.stage);
        let name = _getSectionName(state.stage);
        let arr;

        if (!state.isMobile) {
            // Enable current
            _updateUIs(sectionsUI, state.stage, true);
            _updateUIs(sectionsCounterUIs, state.stage, true);
        }

        if (sandwichUI) sandwichUI.enable();

        switch (name) {
            case 'cover':
                coverNextUI.enable();

                if (state.isMobile) paginationUI.enable();
                else paginationUI.disable();

                _diagramSelect = () => {};
                break;

            case 'review':
                paginationUI.enable();

                _diagramSelect = _diagramReviewSelectPlusAnalytics;
                break;

            case 'config':
                paginationUI.enable();

                _diagramSelect = _diagramToggleFeature;
                break;

            case 'fix':
                paginationUI.enable();

                arr = model.getSelectedFeatureItemsIds();
                n = arr.length;
                arr.forEach((id, i) => {
                    const uiEl = section.el.querySelector(`[data-counter][data-target-id=${id}]`);
                    if (!uiEl || !uiEl.data) return;
                    const ui = uiEl.data.uiController;
                    if (!ui) return;
                    ui.setValue(i === n - 1 ? 1 : i + 2);
                    ui.setTotal(n);
                });

                _diagramSelect = _diagramFixDescriptionSelect;
                break;
        }
        // Disable previous
        name = _getSectionName(state.prevStage);

        if (state.isMobile) {
            _diagramSelect = _diagramToggleFeature;
        }

        if (!state.isMobile) {
            if (state.prevStage > -1) {
                _updateUIs(sectionsUI, state.prevStage, false);
                _updateUIs(sectionsCounterUIs, state.prevStage, false);
            }
        }

        switch (name) {
            case 'cover':
                coverNextUI.destroy();
                coverNextUI = null;
                // If cover could be replayed Disable coverNextUI instead
                if (coverNextUI) {
                    coverNextUI.disable();
                }

                break;
        }

        paginationUI.setValue(state.stage - 1);
    }

    if (force) {
        // for (n = )
        _updateNextUI(state.firstStage + state.availableNumStages - 1, false);
    }
}

function _getSectionName(stage) {
    if (stage < state.firstStage || stage > state.firstStage + state.availableNumStages) return null;
    if (stage < 0 || stage > sectionsControls.length - 1) return null;
    return sectionsNames[stage];
}

function _getSection(stage) {
    if (stage < state.firstStage || stage > state.firstStage + state.availableNumStages) return null;
    if (stage < 0 || stage > sectionsControls.length - 1) return null;
    return sectionsControls[stage];
}

function _showSection(section, delay) {
    if (!section) return false;
    section.enable();
    section.show(delay);
}

function _hideSection(section, disable, destroy) {
    if (!section) return false;
    if (disable) section.disable();
    section.hide(destroy);
}

function _nextStage(force) {
    const t = new Date().getTime();
    if (t - state.lastStageChaneTimestamp < 1000 && !force) return;

    if (!_hasNextStage()) return;

    _gotoSection(state.stage + 1);

    state.lastStageChaneTimestamp = t;
}

function _prevStage(force) {
    const t = new Date().getTime();
    if (t - state.lastStageChaneTimestamp < 1000 && !force) return;

    if (!_hasPrevStage()) return;

    _gotoSection(state.stage - 1);

    state.lastStageChaneTimestamp = t;
}

function _gotoSectionHandler(index) {
    const t = new Date().getTime();
    if (t - state.lastStageChaneTimestamp < 1000) return;

    index++;

    if (index < state.firstStage || index > state.firstStage + state.availableNumStages - 1) return;
    _gotoSection(index);

    state.lastStageChaneTimestamp = t;
}

function _gotoSection(index) {
    state.prevStage = state.stage;
    state.stage = index;
    state.stageChanged = true;
    state.prevLayer = state.layer;
    state.layer = _getLayerNameByStage(state.stage);
    state.layerChanged = state.layer !== state.prevLayer;
    _updateUIState();
    _updateState();

    if (sandwichUI) sandwichUI.close();
}

function _unlockNextStage() {
    state.availableNumStages++;
    _updateNextUI(state.firstStage + state.availableNumStages - 2, true);
}

function _lockLastStage() {
    _updateNextUI(state.firstStage + state.availableNumStages - 2, false);
    state.availableNumStages--;
}

const _updateNextUI = function (i, b) {
    sectionsNextButtons[i].forEach(btn => {
        if (!btn) return;
        btn.dataset.active = b;
    });
};

const _updateUIs = function (arr, i, b) {
    const uis = arr[i];
    if (!uis) return;
    uis.forEach(ui => {
        if (!ui) return;
        if (b) ui.enable();
        else ui.disable();
    });
};

function _removeCoverStage() {
    state.firstStage = 1;
    state.availableNumStages--;
    sectionsControls[0] = null;
}

function _hasNextStage() {
    return state.stage < state.firstStage + state.availableNumStages - 1;
}

function _hasPrevStage() {
    return state.stage > state.firstStage;
}

function _getLayerNameByStage(stage) {
    switch (stage) {
        case -1:
        case 0:
            return 'cover';
        default:
            return '';
    }
}

function _updateCenter(mis) {
    const r = -50;
    centralDiagram.setCenter(mis.vector.x * r, mis.vector.y * r);
    centralDiagramBack.setCenter(mis.vector.x * r, mis.vector.y * r);
}

function _setFunctions(isMobile) {
    if (isMobile) {
        _updateCommonElements = _updateCommonElementsMobile;
        return;
    }
    _updateCommonElements = _updateCommonElementsDesktop;
}

function _handleResize() {
    const sizeMode = SizeMode();
    const isMobile = sizeMode === 'mobile_portrait' || sizeMode === 'mobile_landscape';
    if (state.sizeMode !== sizeMode) _updateVpsResizeBehaviour(sizeMode);

    if (state.isMobile !== isMobile) _setFunctions(isMobile);

    vpsResizeBehaviour.resize();
    vpsResizeBehaviourAside.resize();

    if (state.sizeMode !== sizeMode) {
        if (previewIlln) previewIlln.resize(sizeMode);

        /*
        if (coverNextUI) {
            coverNextUI.setOrientation(isMobile ? 'y' : 'x');
            coverNextUI.handleClick = !isMobile;
        }
        */

        state.sizeMode = sizeMode;
    }

    sectionsUI.forEach(arr => {
        arr.forEach(ui => {
            if (!ui) return;
            ui.resize(sizeMode);
        });
    });

    if (state.isMobile !== isMobile) {
        if (isMobile) {
            _deinitCentralDiagram();
            _initSectionsMobile();
            _initSandwich();
        } else {
            _deinitSectionsMobile();
            _deinitSandwich();
            _initCentralDiagram();
        }

        if (isMobile) {
            _removeCustomListeners();
            _addCustomListenersMobile();
        } else {
            _removeCustomListenersMobile();
            _addCustomListeners();
        }

        _updateUIState(true);
        _updateState(true);

        state.isMobile = isMobile;
    }

    if (!state.isMobile && typeof currentSection.getItemRefY !== 'undefined') _updatePointOutlineY(currentSection.getItemRefY(model.getSelectedReviewItemI()));
}

function _updateVpsResizeBehaviour(sizeMode) {
    if (vpsResizeBehaviour) vpsResizeBehaviour.clear();
    if (vpsResizeBehaviourAside) vpsResizeBehaviourAside.clear();

    let init = ViewportsResizeBehaviour;
    let initAside = ViewportsResizeBehaviour;
    let selectorMainRef = '.stage__viewport';
    let sMain = 1 / 0.88;
    let sAside = 1.27;
    switch (sizeMode) {
        case 'portrait':
            init = ViewportsPortraitResizeBehaviour;
            initAside = ViewportsPortraitResizeBehaviour;
            sMain = 1.65;
            sAside = 1.27 * 1.65 * 0.88;
            break;

        case 'mobile_portrait':
        case 'mobile_landscape':
            init = ViewportsSyncTopResizeBehaviour;
            initAside = NoneViewportsResizeBehaviour;
            selectorMainRef = '.section--1 .stage__viewport';
            sMain = 1;
            sAside = 0;
            break;
    }
    vpsResizeBehaviour = init([...document.querySelectorAll('.sections__viewport--main')], document.querySelector(selectorMainRef), sMain);
    vpsResizeBehaviourAside = initAside([...document.querySelectorAll('.sections__viewport--aside')], document.querySelector('.stage__viewport'), sAside);
}

function init() {
    const sizeMode = state.sizeMode = SizeMode();
    state.isMobile = sizeMode === 'mobile_portrait' || sizeMode === 'mobile_landscape';

    _setFunctions(state.isMobile);

    _initSections();
    _initUI();
    _initPreviewIllustration();
    _initTotalValueDisplay();
    _initDiagramFeaturesControl();

    if (state.isMobile) {
        _initSectionsMobile();
        _initSandwich();
    } else _initCentralDiagram();

    _updateVpsResizeBehaviour(state.sizeMode);

    model.selectPreset(state.review.region);
    body.dataset.featuresFixAvailable = !model.isValuesSetBlank;

    _updateUIState(true);
    _updateState(true);

    if (!state.isMobile) _updateCenter({vector: {x: 0, y: 0}});

    _handleResize();
    return this;
}

function start() {
    if (state._started) return;

    state._started = true;

    _handleResize();

    previewIlln.show();
    MIS.start();

    // After scroll
    _nextStage(true);

    _addListeners();
    if (state.isMobile) _addCustomListenersMobile();
    else _addCustomListeners();

    return this;
}

function _nextStageCover() {
    document.querySelector('.section--cover').classList.add('hide');
    if (state.isMobile) {
        _nextStage();
    } else {
        coverVideoBg.startcoverout();
    }
    analyticsEvent('Button', 'click', 'Start');
    if (coverNextUI) coverNextUI.removeListener('go', _nextStageCover);
}

function _nextStageVideoCoverEnded() {
    if (!state.isMobile) {
        setTimeout(() => {
            _nextStage();
        }, 700);
    }
    coverVideoBg.evEmit.removeListener('coverEnded', _nextStageVideoCoverEnded);
}

function _addListeners() {
    // On scroll, click etc.

    diagramFeaturesControl.on('select', _onDiagramSelect);

    coverVideoBg.evEmit.once('coverEnded', _nextStageVideoCoverEnded);

    coverNextUI.once('go', _nextStageCover);

    paginationUI.on('changed', _gotoSectionHandler);

    sectionsUI.forEach(arr => {
        arr.forEach(ui => {
            // Make a map if there are more types of ui than one
            if (!ui) return;
            ui.on('changed', _onChangeRegion);
        });
    });

    window.addEventListener('resize', _handleResize);
}

function _addCustomListeners() {
    // On scroll, click etc.

    // DESKTOP:
    centralDiagram.on('select', _onDiagramSelect);

    const j = sectionsNextButtons.length - 2;
    sectionsNextButtons.forEach((arr, i) => {
        arr.forEach(btn => {
            if (!btn) return;
            if (i === j) btn.dataset.active = !model.isValuesSetBlank;
            btn.addEventListener('click', _nextStage);
        });
    });

    sectionsBackButtons.forEach(arr => {
        arr.forEach(btn => {
            if (!btn) return;
            btn.addEventListener('click', _prevStage);
        });
    });

    sectionsCounterUIs.forEach(arr => {
        arr.forEach(btn => {
            if (!btn) return;
            btn.on('go', _nextDetail);
        });
    });

    MIS.on('update', _updateCenter);
}

function _removeCustomListeners() {
    // On scroll, click etc.

    // centralDiagram: has been destroyed

    const j = sectionsNextButtons.length - 2;
    sectionsNextButtons.forEach((arr, i) => {
        arr.forEach(btn => {
            if (!btn) return;
            if (i === j) btn.dataset.active = false;
            btn.removeEventListener('click', _nextStage);
        });
    });

    sectionsBackButtons.forEach(arr => {
        arr.forEach(btn => {
            if (!btn) return;
            btn.removeEventListener('click', _prevStage);
        });
    });

    MIS.off('update', _updateCenter);
}

function _addCustomListenersMobile() {
    const j = sectionsNextButtons.length - 2;
    sectionsNextButtons[j].forEach(btn => {
        if (!btn) return;
        btn.dataset.active = !model.isValuesSetBlank;
        btn.addEventListener('click', _nextStage);
    });

    sectionsBackButtons[sectionsBackButtons.length - 1].forEach(btn => {
        if (!btn) return;
        btn.addEventListener('click', _scrollToConfig);
    });

    sectionInView.forEach((inview, i) => {
        if (!inview) return;
        inview
            .on('enter', () => {
                // console.log('enter', el, i)
                if (i < 1) return;
                // Enable Section
                _updateUIs(sectionsUI, i, true);
                _updateUIs(sectionsCounterUIs, i, true);
            })
            .on('exit', () => {
                // console.log('exit', el, i)
                if (i < 1) return;
                // Disable Section
                _updateUIs(sectionsUI, i, false);
                _updateUIs(sectionsCounterUIs, i, false);
            });
        inview.check();
    });

    sectionBasicContentsInView.forEach((inview, i) => {
        if (!inview) return;
        inview
            .on('enter', el => {
                // console.log('enter', el, i)
                el.parentNode.parentNode.classList.add('visible');

                if (scrollTransition) return;
                const name = _getSectionName(state.stage);
                if (name !== 'cover') {
                    _gotoSectionHandler(i - 1);
                    sections[i].dataset.hidePoint = false;

                    // TODO: listen scroll to hide point again
                    // window.addEventListener('scroll', )
                }
            })
            .on('exit', el => {
                // console.log('exit', el)
                el.classList.remove('visible');
            });
        inview.check();
    });

    sectionDetailsInView.forEach((inview, i) => {
        if (!inview) return;
        inview.on('enter', el => {
            // console.log('enter', el, i,  _getSectionName(i))
            if (scrollTransition) return;

            sections.forEach((sn, j) => {
                sn.dataset.hidePoint = j === i ? 1 : 2;
            });

            if (i !== state.stage && _getSectionName(i) !== 'fix') return;
            const id = el.getAttribute('id');
            if (!id || id.length < 1) return;
            // console.log(id)
            scrollTransition = true;

            TweenMax.to(window, 0.3, {
                scrollTo: {y: '#' + id, autoKill: false},
                onComplete: () => {
                    scrollTransition = false;
                }
            });
        });
        inview.check();
    });

    sectionDetailsItemsInView.on('enter', el => {
        el.classList.add('visible');
    });

    sectionUIInView.forEach((inview, i) => {
        if (!inview) return;
        inview.on('enter', el => {
            // console.log('enter', el, i,  _getSectionName(i))
            if (scrollTransition) return;

            sections.forEach((sn, j) => {
                sn.dataset.hidePoint = j === i ? 1 : 2;
            });
            if (i !== state.stage) return;

            const id = el.getAttribute('id'); // console.log(id)
            if (!id || id.length < 1) return;

            scrollTransition = true;

            TweenMax.to(window, 0.3, {
                scrollTo: {y: '#' + id, autoKill: false},
                onComplete: () => {
                    scrollTransition = false;
                }
            });
        });
        inview.check();
    });
}

function _removeCustomListenersMobile() {
    TweenMax.killTweensOf(window);

    const j = sectionsNextButtons.length - 2;
    sectionsNextButtons[j].forEach(btn => {
        if (!btn) return;
        btn.dataset.active = false;
        btn.removeEventListener('click', _nextStage);
    });
}

const _onDiagramSelect = function (i) {
    _diagramSelect(i);
};

let _diagramSelect = () => {};

const _diagramReviewSelect = function (i) {
    model.selectReviewItem(i);
    body.dataset.reviewRiskId = model.getSelectedReviewItemId();

    const section = _getSection(state.stage);
    section.showItem(i);

    TweenMax.delayedCall(0.01, _updatePointOutline, [section.getItemRefY(i), model.getSelectedReviewCurrentValue()]);
};

const _updatePointOutline = function (y, val) {
    centralDiagramOlPt.setY(y);
    centralDiagramOlPt.setValue(val);
};

const _updatePointOutlineY = function (y) {
    centralDiagramOlPt.setY(y);
};

const _diagramReviewSelectPlusAnalytics = function (i) {
    _diagramReviewSelect(i);
    if (i < 0 || i > __reviewDetails.length - 1) return;
    analyticsEvent('Button', 'click', 'Toggle risk:' + __reviewDetails[i]);
};

const _diagramReviewHide = function () {
    delete body.dataset.reviewRiskId;
};

const _diagramFixDescriptionSelect = function (i) {
    model.selectFixItem(i);
    body.dataset.fixRiskId = model.getSelectedFixItemId();

    const section = _getSection(state.stage);
    section.showItem(model.getSelectedFixIndex());

    diagramFeaturesControl.activateFeature(model.getSelectedFixIndex());
    if (centralDiagram) centralDiagram.activateFeature(model.getSelectedFixIndex());
};

const _diagramFixDescriptionHide = function () {
    delete body.dataset.fixRiskId;
};

const _nextDetail = function () {
    const name = _getSectionName(state.stage);
    let section;
    switch (name) {
        case 'fix':
            model.nextFixItem();
            body.dataset.fixRiskId = model.getSelectedFixItemId();

            section = _getSection(state.stage);
            section.showItem(model.getSelectedFixIndex());

            diagramFeaturesControl.activateFeature(model.getSelectedFixIndex());
            if (centralDiagram) centralDiagram.activateFeature(model.getSelectedFixIndex());

            break;
    }
};

const _diagramToggleFeature = function (i) {
    const b = model.isValuesSetBlank;

    model.toggleFeature(i);
    if (centralDiagram) centralDiagram.setValues(model.getValuesSet(), !model.isValuesSetBlank);
    _invalidateTotalValue();

    if (fixSectionsControl) fixSectionsControl.selectItem(i, model.getFeatureState(i));

    if (b === model.isValuesSetBlank) return;

    body.dataset.featuresFixAvailable = !model.isValuesSetBlank;
    if (model.isValuesSetBlank) _lockLastStage();
    else _unlockNextStage();
};

function _onChangeRegion(value, label) {
    state.review.region = model.selectPreset(value);

    if (reviewSectionsControl) reviewSectionsControl.setItemsValues(model.getSelectedPresetValues());

    if (_getSectionName(state.stage) !== 'review') return;

    analyticsEvent('Button', 'click', `Switch: ${label}`);

    // Change diagram for Russia or the world
    if (centralDiagram) centralDiagram.setValues(model.getSelectedPresetValues(), true);
}

const Project = {};

Project.init = init.bind(Project);
Project.start = start.bind(Project);

module.exports = Project;



// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/ProjectSingleton.js